<template>
  <popupLayout>
    <button type="button" class="bootbox-close-button close" data-dismiss="modal" aria-hidden="true" style="margin-top: -10px;" @click="$parent.setShowStayGiveup(false);">×</button>
    <header class="text-center">
    </header>
    <div class="bootbox-body">
      <div class="row form-group mb-lg">
        <div class="col-md-12">
          {{msg}}{{isQuit ? "(已上傳放棄住宿切結書)" : ""}}
        </div>
      </div>
      <div class="row form-group mb-lg">
        <div class="col-md-12">
          是否放棄入住宿?
        </div>
        <div class="col-md-12">
          <a href="javascript:;" style="color: #337ab7" @click="downloadFile('放棄住宿切結書.pdf', '/api/room/downloadGiveUpFile')">放棄住宿切結書格式</a>
        </div>
        <div class="col-md-12">
          <b>上傳放棄住宿切結書</b>
          <input type='file' @change='getQuitProve($event, id)'/>
        </div>
      </div>
    </div>
  </popupLayout>
</template>
<script>
import popupLayout from './popupLayout';
export default {
  components:{
    popupLayout
  },
  props:['msg','id', 'isQuit'],
  data(){
    return {
    }
  },
  methods:{
    getQuitProve(e, id) {
      this.quitProveFile = null;
      this.quitProveFile = e.target.files[0];
      this.uploadFileQuitProve(e, id);
    },
    uploadFileQuitProve(e, id) {
      const api = `/api/Room/giveUpRoomApply/${id}`;
      let formData = new FormData();
      formData.append("quitProveFile", this.quitProveFile);
      this.$axios.post(api, formData).then(resp => {
        if (resp.data.status === "success") {
          bootbox.alert(resp.data.msg);
          this.$parent.setShowStayGiveup(false);
        } else {
          bootbox.alert(resp.data.msg);
        }
      });
      e.target.value = "";
    }
  }
}
</script>
